import {
  Divider,
  DownloadLink,
  MainHeading,
  PolicyPageWrapper,
  TableTextContent,
  TitleTextContent,
} from '@rimactechnology/rimac-ui-lib';
import { Fragment, ReactNode } from 'react';

import { PrivacyPolicyPoliciesDynamicZone } from '@/api';

interface Props {
  // the dynamicZone type is same for all policies
  data: PrivacyPolicyPoliciesDynamicZone[];
  children?: ReactNode;
}

export default function EnhancedPolicyPageWrapper({ data, children }: Props) {
  return (
    <PolicyPageWrapper>
      <Fragment>
        {children}
        {data?.map((policy, index) => {
          switch (policy?.__typename) {
            case 'ComponentPoliciesMainHeading':
              return (
                <MainHeading
                  key={`componentPoliciesMainHeading-${index}`}
                  useCase="technology"
                  richText={policy.text}
                  parentIndex={index}
                />
              );
            case 'ComponentPoliciesDownloadLink':
              return (
                <DownloadLink
                  key={`componentPoliciesDownloadLink-${index}`}
                  label={policy.label || ''}
                  href={policy.link || ''}
                  useCase="technology"
                />
              );
            case 'ComponentPoliciesTableTextContent':
              return (
                <TableTextContent
                  key={`componentPoliciesTableTextContent-${index}`}
                  useCase="technology"
                  text={policy.richText}
                  parentIndex={index}
                  tableData={{
                    headings: (policy.tableHead || []).map(
                      (heading) => heading?.headingItem || '',
                    ),
                    values: (policy.tableRow?.table_rows?.data || []).map(
                      (row) =>
                        (row.attributes?.rows || []).map(
                          (item) => item?.item || '',
                        ),
                    ),
                  }}
                />
              );
            case 'ComponentPoliciesTitleTextContent':
              return (
                <TitleTextContent
                  key={`componentPoliciesTitleTextContent-${index}`}
                  richText={policy.text}
                  useCase="technology"
                  parentIndex={index}
                />
              );
            case 'ComponentPoliciesDevider':
              return <Divider key={`componentPoliciesDevider-${index}`} />;
          }
        })}
      </Fragment>
    </PolicyPageWrapper>
  );
}
